import styled from 'styled-components/macro';
import { NavStyled } from '@yme/molecules/steps-section/styled';
export const StepsSectionContainerStyled = styled.div `
  ${NavStyled} {
    display: flex;
    flex-direction: row;
  }
`;
